import { render, staticRenderFns } from "./CompensationProcedurePlans.vue?vue&type=template&id=324918e8&scoped=true"
import script from "./CompensationProcedurePlans.vue?vue&type=script&lang=js"
export * from "./CompensationProcedurePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324918e8",
  null
  
)

export default component.exports